document.addEventListener("DOMContentLoaded", () => {
  const waitForElementToExist = (selector) => {
    return new Promise(resolve => {
      if (document.querySelector(selector)) {
        return resolve(document.querySelector(selector));
      }

      const observer = new MutationObserver(() => {
        if (document.querySelector(selector)) {
          resolve(document.querySelector(selector));
          observer.disconnect();
        }
      });

      observer.observe(document.body, {
        subtree: true,
        childList: true,
      });
    });
  }

  // Shop pay replace node - move above product form
  waitForElementToExist('shopify-payment-terms').then(selector => {
    const shopPayEl = selector;
    shopPayEl.classList.add('active');
    selector.remove();
    const productForm = document.querySelector('.product-form');
    if (productForm) {
      productForm.insertAdjacentElement('beforebegin', shopPayEl);
    }
  });

  //Sticky Add to cart button

  const tablet = window.matchMedia("(max-width: 750px)").matches;
  const product_form = document.querySelector('.product-single__metaWrapper .product-form');
  const atc_btn = document.querySelector(".main-product-form__cart-submit") || false;
  const stickyContainer = document.querySelector('.main-product-form__item--submit');
  const stickyPriceDisplay = document.querySelector('.main-product-form__item--submit .product-form__button-price');

  if (tablet && atc_btn) {
    let timeout;

    const addStickyClass = () => {
      const chat = document.querySelector('#shopify-chat') || false;

      clearTimeout(timeout);
      timeout = setTimeout(() => {
        const rect = atc_btn?.getBoundingClientRect();
        const product_form_rect = product_form.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (scrollTop > rect.top / 2 && product_form_rect.bottom > 0) {
          stickyContainer.classList.remove("sticky");
          if (chat) chat.classList.remove('hidden');
        } else {
          stickyContainer.classList.add("sticky");
          if (chat) chat.classList.add('hidden');
        }
      }, 100);
    }

    window.addEventListener("scroll", addStickyClass);
  }

  // Universal Sticky Price Update System
  // Updates sticky button price based on any dynamic price changes

  if (stickyPriceDisplay) {
    let currentUnitPrice = 0; // Store the current unit price

    // Function to parse price string to number (e.g., "$30.00" -> 3000 cents)
    const parsePriceToNumber = (priceString) => {
      if (!priceString) return 0;
      // Remove currency symbols and convert to cents
      const cleaned = priceString.replace(/[^0-9.]/g, '');
      return Math.round(parseFloat(cleaned) * 100);
    };

    // Function to format price number back to display string
    const formatPriceFromNumber = (priceInCents) => {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      }).format(priceInCents / 100);
    };

    // Function to get current quantity
    const getCurrentQuantity = () => {
      const qtyInput = document.querySelector('[data-quantity-input]');
      return qtyInput ? parseInt(qtyInput.value) || 1 : 1;
    };

    // Function to update the sticky button price display
    const updateStickyPrice = (newPrice, quantity = null) => {
      if (!stickyPriceDisplay || !newPrice) return;

      // Parse the unit price
      currentUnitPrice = parsePriceToNumber(newPrice);

      // Get quantity (use provided or current)
      const qty = quantity !== null ? quantity : getCurrentQuantity();

      // Calculate total price
      const totalPrice = currentUnitPrice * qty;

      // Format and display
      stickyPriceDisplay.textContent = formatPriceFromNumber(totalPrice);
    };

    // Function to recalculate with current unit price and new quantity
    const updateStickyPriceWithQuantity = (quantity) => {
      if (currentUnitPrice > 0) {
        const totalPrice = currentUnitPrice * quantity;
        stickyPriceDisplay.textContent = formatPriceFromNumber(totalPrice);
      }
    };

    // Listen for custom price change events (from bundle selector, etc.)
    document.addEventListener('stickyPriceUpdate', (event) => {
      if (event.detail && event.detail.formattedPrice) {
        updateStickyPrice(event.detail.formattedPrice);
      }
    });

    // Watch for Recharge widget price changes
    const observeRechargeWidget = () => {
      const rechargeContainer = document.querySelector('.rc-container-wrapper');

      if (!rechargeContainer) return;

      // Function to get active price from Recharge widget
      const getRechargeActivePrice = () => {
        // Check for active subscription option
        const activeOption = rechargeContainer.querySelector('.rc-option--active');
        if (activeOption) {
          const priceElement = activeOption.querySelector('[data-price-subsave], [data-price-onetime]');
          if (priceElement) {
            return priceElement.textContent.trim();
          }
        }

        // Fallback to one-time price
        const onetimePrice = rechargeContainer.querySelector('[data-price-onetime]');
        if (onetimePrice) {
          return onetimePrice.textContent.trim();
        }

        return null;
      };

      // Update sticky price when Recharge widget changes
      const updateFromRecharge = () => {
        const price = getRechargeActivePrice();
        if (price) {
          updateStickyPrice(price);
        }
      };

      // Listen for radio button changes
      const radioButtons = rechargeContainer.querySelectorAll('input[type="radio"]');
      radioButtons.forEach(radio => {
        radio.addEventListener('change', () => {
          setTimeout(updateFromRecharge, 100);
        });
      });

      // MutationObserver for dynamic changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          // Check if the active class changed
          if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            const target = mutation.target;
            if (target.classList.contains('rc-option') || target.classList.contains('rc-option--active')) {
              updateFromRecharge();
            }
          }
        });
      });

      observer.observe(rechargeContainer, {
        attributes: true,
        attributeFilter: ['class'],
        subtree: true
      });

      // Initial update
      updateFromRecharge();
    };

    // Wait for Recharge widget to load
    waitForElementToExist('.rc-container-wrapper').then(() => {
      setTimeout(observeRechargeWidget, 500);
    });

    // Watch for main product price changes (variant changes)
    const mainPriceElement = document.querySelector('.product__price .price__regular .price-item--regular');
    if (mainPriceElement) {
      const priceObserver = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'childList' || mutation.type === 'characterData') {
            const newPrice = mainPriceElement.textContent.trim();
            if (newPrice && !document.querySelector('.rc-option--active')) {
              // Only update if Recharge widget is not active
              updateStickyPrice(newPrice);
            }
          }
        });
      });

      priceObserver.observe(mainPriceElement, {
        childList: true,
        characterData: true,
        subtree: true
      });
    }

    // Watch for quantity changes
    const qtyInput = document.querySelector('[data-quantity-input]');
    if (qtyInput) {
      // Listen for input changes (manual typing)
      qtyInput.addEventListener('input', (e) => {
        const newQuantity = parseInt(e.target.value) || 1;
        updateStickyPriceWithQuantity(newQuantity);
      });

      // Listen for change events (when input loses focus)
      qtyInput.addEventListener('change', (e) => {
        const newQuantity = parseInt(e.target.value) || 1;
        updateStickyPriceWithQuantity(newQuantity);
      });

      // Listen for increase/decrease button clicks
      const increaseBtn = document.querySelector('[data-action="increase-quantity"]');
      const decreaseBtn = document.querySelector('[data-action="decrease-quantity"]');

      if (increaseBtn) {
        increaseBtn.addEventListener('click', () => {
          // Wait a bit for the input value to update
          setTimeout(() => {
            const newQuantity = getCurrentQuantity();
            updateStickyPriceWithQuantity(newQuantity);
          }, 50);
        });
      }

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', () => {
          // Wait a bit for the input value to update
          setTimeout(() => {
            const newQuantity = getCurrentQuantity();
            updateStickyPriceWithQuantity(newQuantity);
          }, 50);
        });
      }
    }
  }



  // Accordion Content Show More/Less toggle functionality
  const accordionContents = document.querySelectorAll('[data-accordion-content]');
  const accordionToggleBtns = document.querySelectorAll('[data-accordion-toggle]');

  // Check each accordion content and show button if height > 350px
  accordionContents.forEach((content, index) => {
    const toggleBtn = accordionToggleBtns[index];

    if (!toggleBtn) return;

    // Check the actual scrollHeight of the content
    const contentHeight = content.scrollHeight;

    if (contentHeight > 350) {
      // Content is taller than 350px, show the button and add collapsed class
      toggleBtn.classList.remove('hidden');
      content.classList.add('accordion-content-collapsed');

      // Add click event listener
      toggleBtn.addEventListener('click', function () {
        const isExpanded = content.classList.contains('accordion-content-expanded');
        const toggleText = this.querySelector('.accordion-toggle-text');
        const accordion = content.closest('.product__accordion');

        if (isExpanded) {
          // Collapse: Scroll to top of accordion smoothly first
          if (accordion) {
            accordion.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });
          }

          // Delay the collapse to allow scroll to happen smoothly
          setTimeout(function () {
            content.classList.remove('accordion-content-expanded');
            content.classList.add('accordion-content-collapsed');
            toggleText.textContent = 'Show More';
            toggleBtn.classList.remove('expanded');
          }, 500);
        } else {
          // Expand: Show all content
          content.classList.remove('accordion-content-collapsed');
          content.classList.add('accordion-content-expanded');
          toggleText.textContent = 'Show Less';
          this.classList.add('expanded');
        }
      });
    }
  });
});